<app-custom-input  [(result)]="vin" restrict="[0-9a-zA-Z]" maxlength="17" styleClass="vin-first" (resultChange)="onVinChange()" ngDefaultControl (keydown)="emitVinEdited()" (paste)="emitVinEdited()"></app-custom-input>

